import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4feebfdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex center" }

import { withDefaults, ref, watch } from 'vue';
import { Modal, Select } from 'ant-design-vue';
import http from '@/api/conentCenter/communal';
import { useRoute } from 'vue-router';
import emitter from '@/utils/mitt';
interface Props {
  visible: boolean;
  centered?: boolean;
  closable?: boolean;
  footer?: null;
  dataSource?: any;
  ok: (...args: any[]) => any;
  close: (...args: any[]) => any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CMoveSort',
  props: {
    visible: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    footer: null,
    dataSource: { default: {} },
    ok: null,
    close: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean, centered: boolean, closable: boolean, footer?: null, dataSource: any, ok: (...args: any[]) => any, close: (...args: any[]) => any };

const route = useRoute();
const gatewayId = route.params.gatewayId;
const aModal = Modal;
const aSelect = Select;
const aSelectOption = Select.Option;


const options = ref([
  {
    name: '',
    id: '',
  },
  {
    name: '',
    id: '',
  },
  {
    name: '',
    id: '',
  },
  {
    name: '',
    id: '',
  },
]);

const parentType = ref();
// const emit = defineEmits(['moveSortId']);

const MoveSortId = () => {
  emitter.emit('changeSortId', parentType.value);
};
const getSortList = () => {
  let params = {
    type: props.dataSource.menuType,
    portal_id: gatewayId,
  };
  http.get_sort_list({ params }).then((res) => {
    options.value = res.data.data;
  });
};
watch(
  () => props.visible,
  () => {
    props.visible ? getSortList() : '';
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aModal), {
      title: "移至分类",
      visible: props.visible,
      centered: props.centered,
      closable: props.closable,
      onCancel: props.close,
      onOk: props.ok
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(" 选择分类： "),
          _createVNode(_unref(aSelect), {
            class: "input_width",
            value: parentType.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((parentType).value = $event)),
            placeholder: "请选择分类",
            onChange: MoveSortId
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                return (_openBlock(), _createBlock(_unref(aSelectOption), {
                  key: item.id,
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "centered", "closable", "onCancel", "onOk"])
  ]))
}
}

})